import styled from 'styled-components';

export const Link = styled.a`
  display: inline-flex;
  align-items: center;
  ${({ theme }) => theme.gap(3)}
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(18)};
  color: ${props => props.theme.unisystem.arrowLink.color};
  margin-top: ${props => props.theme.space(9)};
  text-decoration: none;

  svg {
    width: 18px;

    path {
      fill: ${props => props.theme.unisystem.arrowLink.color};
    }
  }

  &:hover {
    text-decoration: underline;
  }
`;
